import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { TextField, Box, Button, Typography } from "@mui/material";
import POPIAcceptanceBox from "../Partials/POPIAcceptanceBox";
import UpdatePasswordSMSSent from "../Partials/SMSSentPopup";
import { updateForgotPasswordSMS } from "../../api/admin";
import "./Styling.css";
import { s3BaseUrl } from "../../config/envConfig";

export default function ForgotPassword() {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [formData, setFormData] = useState({
    username: "",
    mobileNumber: "",
  });
  const [formErrors, setFormErrors] = useState({
    username: false,
    mobileNumber: false,
  });
  const [formValid, setFormValid] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showPopiBox, setShowPopiBox] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const validateField = (key, value) => {
    let isValid = value.length !== 0;
    if (key === "mobileNumber") {
      isValid = isValid && value.length === 10 && /^\d+$/.test(value);
    }
    return isValid;
  };

  const handleBlur = (key, value) => {
    const isValid = validateField(key, value);
    setFormErrors((prevState) => ({
      ...prevState,
      [key]: !isValid,
    }));
  };

  const getSMS = async () => {
    const smsResponse = await updateForgotPasswordSMS(
      formData.username,
      formData.mobileNumber
    );

    if (smsResponse.code === 200) {
      setShowModal(true);
      setModalTitle("SMS Successfully Sent");
      setModalDescription("SMS successfully sent to your mobile number.");
    } else {
      setShowModal(true);
      setModalTitle("SMS Not Sent");
      setModalDescription(
        "There was an error sending the SMS to your mobile number."
      );
    }
  };

  const handleSubmit = () => {
    const newFormErrors = {
      ...formErrors,
      mobileNumber: !validateField("mobileNumber", formData.mobileNumber),
    };

    setFormErrors(newFormErrors);

    const isValid = Object.values(newFormErrors).every((error) => !error);

    if (isValid) {
      setFormValid(true);
      setShowPopiBox(true);
      setShowError(false);
      getSMS();

      setIsButtonDisabled(true);
      setTimeout(() => setIsButtonDisabled(false), 5000);
    } else {
      setFormValid(false);
      setShowPopiBox(false);
      setShowError(true);
    }
  };

  useEffect(() => {
    const isValid = Object.values(formErrors).every((error) => !error);
    setFormValid(isValid);
  }, [formErrors]);

  function POPIDecline() {
    setShowPopiBox(false);
  }

  const closeModalAndRedirect = () => {
    setShowModal(false);
    history.push("/login");
  };

  return (
    <>
      <UpdatePasswordSMSSent
        display={showModal}
        handler={closeModalAndRedirect}
        title={modalTitle}
        message={modalDescription}
      />
      <div
        className="logoBackground"
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div>
            <img
              src={
                s3BaseUrl + "/mobitutorza_logo_full.png"
              }
              alt={"MobiTutorZA Logo"}
              width={"250px"}
              height={"250px"}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "80%",
              alignItems: "center",
            }}
          >
            <div>
              <p
                style={{
                  color: "white",
                  fontSize: "1.25em",
                  fontWeight: "bold",
                }}
              >
                Forgot Password
              </p>
            </div>
            <hr
              style={{
                color: "white",
                marginBottom: "20px",
                width: "100%",
                maxWidth: "400px",
              }}
            />

            <Box
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                width: "100%",
                maxWidth: "400px",
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "rgba(224, 224, 224, 0.12)",
                      },
                      "&:hover fieldset": {
                        borderColor: "rgba(224, 224, 224, 0.12)",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#FBCD02",
                      },
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.username}
                label="Username"
                variant="outlined"
                onChange={(e) => handleInputChange("username", e.target.value)}
                onBlur={(e) => handleBlur("username", e.target.value)}
              />
              {formErrors.username && (
                <Typography
                  sx={{
                    color: "red",
                    fontSize: "0.8rem",
                    marginTop: "-12px",
                    textAlign: "left",
                  }}
                >
                  Username is required
                </Typography>
              )}

              <TextField
                sx={{
                  backgroundColor: "rgba(224, 224, 224, 0.12)",
                  borderRadius: "5px",
                  "& .MuiInputBase-input": {
                    padding: "15px 14px",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00112e",
                    "--joy-palette-primary-500": "#01ACC7",
                  },
                  width: "100%",
                }}
                InputProps={{
                  sx: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#FBCD02",
                    },
                  },
                }}
                InputLabelProps={{
                  sx: {
                    color: "white",
                    "&.Mui-focused": {
                      color: "#FBCD02",
                    },
                  },
                }}
                error={formErrors.mobileNumber}
                label="Mobile Number"
                variant="outlined"
                onChange={(e) =>
                  handleInputChange("mobileNumber", e.target.value)
                }
                onBlur={(e) => handleBlur("mobileNumber", e.target.value)}
              />
              {formErrors.mobileNumber && (
                <Typography
                  sx={{
                    color: "red",
                    fontSize: "0.8rem",
                    marginTop: "-12px",
                    textAlign: "left",
                  }}
                >
                  Mobile number is required
                </Typography>
              )}
            </Box>
            <Button
              variant="contained"
              style={{
                marginTop: "20px",
                backgroundColor: "#FBCD02",
                color: "#00112e",
                width: "100%",
                height: "3.2em",
                fontWeight: "bold",
                maxWidth: "400px",
                cursor: "pointer",
              }}
              onClick={handleSubmit}
              disabled={isButtonDisabled}
            >
              Send
            </Button>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                maxWidth: "400px",
                marginTop: "10px",
                color: "white",
              }}
            >
              <Button
                variant="outlined"
                style={{
                  width: "100%",
                  height: "3.2em",
                  color: "white",
                  borderColor: "white",
                  cursor: "pointer",
                }}
                onClick={() => history.push("/login")}
              >
                Back
              </Button>
            </div>
          </div>
        </div>
        <div
          style={{
            color: "white",
            fontSize: "1rem",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            maxWidth: "80%",
            alignItems: "center",
            marginBottom: "40px",
          }}
        >
          <span style={{ width: "90%" }}>
            Can't remember your username or have a new contact number?
          </span>
          <Button
            variant="contained"
            style={{
              marginTop: "10px",
              backgroundColor: "#FBCD02",
              color: "#00112e",
              width: "100%",
              height: "3.2em",
              fontWeight: "bold",
              maxWidth: "400px",
              cursor: "pointer",
            }}
            onClick={() =>
              history.push("/contactus", { forgotPassword: "true" })
            }
            disabled={isButtonDisabled}
          >
            Click Here
          </Button>
        </div>
      </div>
    </>
  );
}
